var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-input"},[_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"请输入关闭原因"},model:{value:(_vm.closeReason),callback:function ($$v) {_vm.closeReason=$$v},expression:"closeReason"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-877afed8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/order/dialog/AntWithHold/CloseInput.vue
// module id = null
// module chunks = 